"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgNotifcationIcon = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 12, height: 16, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M1.991 9.918c.41.348.682.818.78 1.332h2.385V7.91A1.878 1.878 0 0 1 3.75 6.092h.938a.939.939 0 0 0 1.875 0H7.5c0 .872-.598 1.607-1.406 1.816v3.34H8.48c.1-.513.374-.986.787-1.337a5.619 5.619 0 0 0 1.983-4.287c0-5.043-6.15-7.52-9.651-3.921a5.617 5.617 0 0 0 .392 8.214ZM5.625 16A1.877 1.877 0 0 0 7.5 14.125H3.75c0 1.034.841 1.875 1.875 1.875ZM2.813 12.188h5.625v1H2.812v-1Z", fill: "#09F5A2" }) }))); };
exports.default = SvgNotifcationIcon;
